import { FormattedMessage } from 'react-intl'

import { IconDocumentCheck, IconDocumentSign, IconDocumentWrite, IconUserWait } from 'components/Icons'

import { Step } from './Step'

type Props = {
	completedStep: 'signup' | 'budget'
	otherApplicantName: string
}

export const MultipleApplicants = ({ completedStep, otherApplicantName }: Props) => (
	<>
		<Step
			icon={<IconDocumentWrite />}
			title={
				<FormattedMessage
					id='flow.nextSteps.multipleApplicants.step1'
					defaultMessage='Your bank details have been submitted'
				/>
			}
			isCompleted
		/>
		<Step
			icon={<IconDocumentSign />}
			title={
				<FormattedMessage
					id='flow.nextSteps.multipleApplicants.step2'
					defaultMessage='Bank details for {otherApplicantName} have been submitted'
					values={{ otherApplicantName }}
				/>
			}
			isCompleted={completedStep === 'budget'}
		/>
		<Step
			icon={<IconDocumentCheck />}
			title={
				<FormattedMessage
					id='flow.nextSteps.multipleApplicants.step3'
					defaultMessage='Budget has been finalized and submitted with {otherApplicantName}'
					values={{ otherApplicantName }}
				/>
			}
			isCompleted={completedStep === 'budget'}
		/>
		<Step
			icon={<IconUserWait />}
			title={
				<FormattedMessage
					id='flow.nextSteps.multipleApplicants.step4'
					defaultMessage='Nordea will process your application once all information has been received.'
				/>
			}
		/>
	</>
)
